import React from 'react';
import Button from '@mui/material/Button';
import { Link as RouterLink } from 'react-router-dom';

const PrimaryButton = ({
  to,
  href,
  size = 'large',
  fullWidth,
  startIcon,
  endIcon,
  onClick,
  type = 'button',
  disabled,
  color = 'primary',
  sx,
  children,
  ...rest
}) => {
  const linkProps = to
    ? { component: RouterLink, to }
    : href
      ? { component: 'a', href }
      : {};

  return (
    <Button
      variant="contained"
      color={color}
      size={size}
      fullWidth={fullWidth}
      startIcon={startIcon}
      endIcon={endIcon}
      onClick={onClick}
      type={type}
      disabled={disabled}
      sx={sx}
      {...linkProps}
      {...rest}
    >
      {children}
    </Button>
  );
};

export default PrimaryButton;
